<template>
    <div :class="$style.container"
         id="target_home"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
         style="flex-grow: 1"
    >
        <header style="height: 40px">
            <el-col :span="8" style="padding-top: 8px">
                <span style="color: #000000;font-size: 22px;">客户变更列表</span>
            </el-col>
            <el-col :span="8" style="text-align: center">
                <div>
                    <el-button-group>
                        <el-button style="color: #409EFF;border-color: #c6e2ff;background-color: #ecf5ff;">未提交</el-button>
                        <el-button @click="dianji">待审批</el-button>
                        <el-button @click="dianji2">已生效</el-button>
                    </el-button-group>
                </div>
            </el-col>
            <!--<el-col :span="8">-->
            <!--<div style="float: right" class="Peopel">-->
            <!--<el-form ref="form" :model="form" label-width="80px">-->
            <!--<el-form-item label="人员">-->
            <!--<el-select v-model="form.people" placeholder="请选择" @change="renyuan">-->
            <!--<el-option-->
            <!--v-for="item in UserList"-->
            <!--:key="item.user_id"-->
            <!--:label="item.user_name"-->
            <!--:value="item.user_id"-->
            <!--:disabled="role=='staff'"-->
            <!--&gt;-->
            <!--</el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->
            <!--</el-form>-->
            <!--</div>-->
            <!--</el-col>-->
        </header>
        <main>

            <el-form ref="searchForm" :model="searchForm" label-width="80px" class="FormClass">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="销售渠道">
                            <el-checkbox-group v-model="channelArray"  @change="handleCheckedCitiesChange">
                                <el-checkbox label="医疗机构" value="HCP" v-if="clientObj.showInstitution"></el-checkbox>
                                <el-checkbox label="零售终端" value="RETAILSTORE" v-if="clientObj.showStore"></el-checkbox>
                                <el-checkbox label="分销客户" value="DISTRIBUTOR" v-if="clientObj.showDistributor"></el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="padding-left: 20px">
                        <el-form-item label="客户名称">
                            <el-input v-model="searchForm.account_name" placeholder="请输入客户名称"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="客户类型">
                            <el-select v-model="searchForm.type" placeholder="请选择客户类型"  style="width: 100%" @change="fangfa3" clearable>
                                <el-option label="HCP" value="HCP" v-if="clientObj.showInstitution"></el-option>
                                <el-option label="经销商" value="DISTRIBUTOR" v-if="clientObj.showDistributor"></el-option>
                                <el-option label="门店" value="RETAILSTORE" v-if="clientObj.showStore"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="padding-left: 20px">
                        <el-form-item label="客户级别">
                            <el-select v-model="searchForm.segment_id" placeholder="请选择客户级别"  style="width: 100%" clearable>
                                <el-option
                                        v-for="item in  ByCategory"
                                        :key="item.key"
                                        :label="item.value1"
                                        :value="item.key"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12" >
                        <el-form-item label="生效日期">

                            <el-date-picker
                                    v-model="searchForm.time"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    style="width: 100%"
                                    value-format="yyyy-MM-dd"
                                    :clearable=false
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12" style="padding-left: 20px">
                        <el-form-item label="填写日期">
                            <el-date-picker
                                    v-model="searchForm.time2"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    style="width: 100%"
                                    value-format="yyyy-MM-dd"
                                    :clearable=false
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row style="margin-top: 20px">
                    <el-button size="mini" style="border: #4a90e2 1px solid;background-color: #4a90e2;color: #fff" @click="handleQueryClick">查询</el-button>
                    <el-button size="mini" style="border: #c51f1f 1px solid;background-color: #c51f1f;color: #fff" @click="eventReset">重置</el-button>
                </el-row>

                <el-row style="margin-top: 15px">
                    <el-col style="border-bottom: 1px dashed #dedede">

                    </el-col>
                </el-row>
            </el-form>

            <el-row style="margin-top: 20px">
                <el-col :span="16"style="margin-top: 15px">

                    <el-button size="small" :class="{inActive:val1,active:val}" style="color: #fff;height: 36px;position: relative;top: 3px;" :disabled="isDisabled" @click="tijiao">
                        <img src="../../assets/images/tijiao.png" alt="" style="position: relative;right: 4px"><span style="position: relative;top: -3px;">提交变更</span>
                    </el-button>
                    <el-button size="medium" type="danger" style="color: #fff;position: relative;top: -1px;" :disabled="isDisabled" @click="quxiao">
                        <span style="font-size: 12px">取消变更</span>
                    </el-button>
                </el-col>
                <el-col :span="8">
                    <el-row type="flex" justify="end">
                        <el-col>
                            <MiniCard
                                    style="margin-right: 20px"
                                    title="待提交总数"
                                    :desc="ClientList.all_count"
                                    color="4a90e2"
                            ></MiniCard>
                        </el-col>
                        <el-col v-if="clientObj.showInstitution">
                            <MiniCard
                                    style="margin-right: 20px"
                                    title="医疗机构"
                                    :desc="ClientList.hcp_count"
                                    color="6bc235"
                            ></MiniCard>
                        </el-col>
                        <el-col v-if="clientObj.showStore">
                            <MiniCard
                                    style="margin-right: 20px"
                                    title="零售终端"
                                    :desc="ClientList.retailstore_count"
                                    color="ff9901"
                            ></MiniCard>
                        </el-col>
                        <el-col v-if="clientObj.showDistributor">
                            <MiniCard
                                    style="margin-right: 20px"
                                    title="分销客户"
                                    :desc="ClientList.distributor_count"
                                    color="f167f0;"
                            ></MiniCard>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>


            <el-row style="margin-top: 20px" >
                <el-table
                        :data="tableData"
                        border
                        stripe
                        header-cell-class-name="headerStyle2"
                        :default-sort = "{prop: 'date', order: 'descending'}"
                        style="width: 100%"
                        @selection-change="handleSelectionChange"
                >
                    <el-table-column
                            fixed
                            type="selection"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            sortable
                            prop="channel"
                            label="销售渠道"
                            width="110"
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.channel == 'HCP'">
                                <span style="margin-left: 5px; ">医疗机构</span>
                            </div>
                            <div v-else>
                                <span style="margin-left: 5px; ">{{scope.row.channel}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            min-width="300"
                            sortable
                            prop="tempname"
                            label="客户"
                    >
                        <template slot-scope="scope">

                            <div>
                                <span style="margin-left: 5px; ">{{scope.row.tempname}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            sortable
                            prop="reference_name"
                            label="类型"
                            width="100"
                    >
                    </el-table-column>
                    <el-table-column
                            sortable
                            prop="segment_name"
                            label="客户级别"
                            width="110"
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.old_segment_name !== scope.row.segment_name">
                                <span style="margin-left: 5px; color: #4A90E2">{{scope.row.old_segment_name}}</span>
                                <span style="color: #4A90E2"> -> </span>
                                <span style="color: #4A90E2">{{scope.row.segment_name}}</span>
                            </div>
                            <div v-else="scope.row.old_segment_name == scope.row.segment_name">
                                <span style="margin-left: 5px; color: #4A90E2">{{scope.row.old_segment_name}}</span><span style="color: #4A90E2">(无变化)</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            sortable
                            prop="account_status"
                            label="目标客户"
                            width="110"
                    >
                        <template  slot-scope="scope">
                            <div v-if="scope.row.account_status == scope.row.old_account_status">
                                <span style="color: #4A90E2" v-if="scope.row.old_account_status=='ACTIVE'">是</span>
                                <span style="color: #4A90E2" v-else="scope.row.old_account_status=='INACTIVE'">否</span>
                                <span style="color: #4A90E2">(无变化)</span>
                            </div>

                            <div v-else="scope.row.account_status!== scope.row.old_account_status">
                                <span style="margin-left: 5px; color: #4A90E2" v-if="scope.row.old_account_status=='ACTIVE'">是</span>
                                <span style="margin-left: 5px; color: #4A90E2" v-else-if="scope.row.old_account_status=='INACTIVE'">否</span>
                                <span style="color: #4A90E2"> -> </span>
                                <span style="color: #4A90E2" v-if="scope.row.account_status=='ACTIVE'">是</span>
                                <span style="color: #4A90E2" v-else-if="scope.row.account_status=='INACTIVE'">否</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            sortable
                            prop="effective_date"
                            label="计划生效"
                            width="120"
                    >
                    </el-table-column>
                    <el-table-column
                            sortable
                            prop="created_date"
                            label="变更填写日期"
                            width="130"
                    >
                    </el-table-column>
                    <el-table-column label="操作" width="72px" class="myclass" fixed="right">
                        <template slot-scope="scope">
                            <el-button
                                    type="warning"
                                    size="mini"
                                    style="margin-right: 10px;float: left;background-color: #ff9901;border: #ff9901 1px solid;"
                                    @click="btn(scope.row)"
                            >详情
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>

            <!--<pagination :page="page" @changePage="changePageClick"></pagination>-->

        </main>



        <!--hcp详情-->
        <el-dialog
                :visible.sync="dialogVisible"
                width="900px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3;margin-top: -70px">
            <div style="margin-top: -40px">
                <el-row style="padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;padding-top: 8px;font-size: 20px">HCP详情
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">
                            <el-button type="danger" size="small" @click="dialogVisible = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div class="HcpClass" >
                    <el-tabs v-model="activeName" >
                        <el-tab-pane label="基本信息" name="first" class="basicInfo">
                            <el-form ref="Hcplist" :model="Hcplist" label-width="120px" style="margin-top: 20px;">

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="科室/部门"
                                                      prop="standard_dept"
                                        >
                                            <el-select v-model="Hcplist.standard_dept"  filterable
                                                       style="width: 100%" disabled  placeholder="  ">
                                                <el-option
                                                        v-for="item in administrative"
                                                        :key="item.key"

                                                        :label="item.value1"
                                                        :value="item.key"
                                                >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" >
                                        <el-form-item label="科室挂牌名称"
                                                      prop="department"
                                        >
                                            <el-input v-model="Hcplist.department" disabled></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="姓名">
                                            <el-input v-model="Hcplist.hcp_name"  disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="性别" >
                                            <el-select v-model="Hcplist.gender"  style="width:100%" disabled  placeholder="   ">
                                                <el-option label="男" value="M"></el-option>
                                                <el-option label="女" value="F"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="职务" >
                                            <el-select v-model="Hcplist.job_title_name"  style="width: 100%" disabled placeholder="  ">
                                                <el-option
                                                        v-for="item in jobtList"
                                                        :key="item.key"

                                                        :label="item.value1"
                                                        :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="职称" >
                                            <el-select v-model="Hcplist.pro_title_name"  style="width: 100%" disabled placeholder="   ">
                                                <el-option
                                                        v-for="item in prolist"
                                                        :key="item.key"

                                                        :label="item.value1"
                                                        :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>


                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="联系电话">
                                            <el-input v-model="Hcplist.mobile"  disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="电子邮件">
                                            <el-input v-model="Hcplist.email" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="生日">
                                            <el-date-picker
                                                    v-model="Hcplist.birthday"
                                                    type="date"
                                                    style="width: 100%"
                                                    placeholder="  "
                                                    value-format="yyyy-MM-dd"
                                                    disabled
                                            >
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="爱好">
                                            <el-input v-model="Hcplist.hobby"  disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>



                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="主治病症">
                                            <el-input v-model="Hcplist.specialties"  disabled></el-input>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="12">
                                        <el-form-item label="门诊时间">
                                            <el-input v-model="Hcplist.consulting_hours"  disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="毕业院校">
                                            <el-input v-model="Hcplist.education"  disabled></el-input>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="12">
                                        <el-form-item label="担任协会职务">
                                            <el-input v-model="Hcplist.fellowships"  disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="专家讲者">
                                            <el-switch
                                                    v-model="Hcplist.speaker"
                                                    active-color="#13ce66"
                                                    disabled
                                            >
                                            </el-switch>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="12">
                                        <el-form-item label="讲者级别">
                                            <el-select v-model="Hcplist.speaker_level_name"  style="width: 100%" disabled  placeholder="  ">
                                                <el-option
                                                        v-for="item in prolist"
                                                        :key="item.key"

                                                        :label="item.value1"
                                                        :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="KOL">
                                            <el-switch
                                                    v-model="Hcplist.kol"
                                                    active-color="#13ce66"
                                                    disabled
                                            >
                                            </el-switch>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="12">
                                        <el-form-item label="KOL级别">
                                            <el-select v-model="Hcplist.kol_level_name"  style="width: 100%" disabled   placeholder="   ">
                                                <el-option
                                                        v-for="item in prolist"
                                                        :key="item.key"
                                                        :label="item.value1"
                                                        :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="客户级别">
                                            <span style="color: #4A90E2" v-model="Hcplist.segment_name" disabled>{{Hcplist.segment_name}}</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="目标客户" >
                                            <el-switch
                                                    v-model="Hcplist.account_status"
                                                    active-color="#13ce66"
                                                    disabled
                                            >
                                            </el-switch>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <!--                            <el-col :span="12">-->
                                    <!--                                <el-form-item label="所属科室" >-->
                                    <!--                                    <el-select v-model="Hcplist.dept_name" placeholder="请选择" style="width: 100%" disabled>-->
                                    <!--                                        <el-option-->
                                    <!--                                                v-for="item in departments"-->
                                    <!--                                                :key="item.dept_id"-->
                                    <!--                                                :label="item.dept_name"-->
                                    <!--                                                :value="item.dept_id">-->
                                    <!--                                        </el-option>-->
                                    <!--                                    </el-select>-->
                                    <!--                                </el-form-item>-->
                                    <!--                            </el-col>-->
                                    <el-col :span="12">
                                        <el-form-item label="在职" >
                                            <el-switch
                                                    v-model="Hcplist.status"
                                                    active-color="#13ce66"
                                                    disabled
                                            >
                                            </el-switch>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="客户编码">
                                            <el-input v-model="Hcplist.hcp_code"  disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </el-tab-pane>
                        <el-tab-pane label="扩展信息" name="second" class="extensionInfo">
                            <div class="subjectList" style="margin-top: 20px;">
                                <el-form   :ref="'list'+j" label-width="120px" v-for="(item,j) in extendedInfo" :model="extendedInfo[j]" :key="item.field_id">
                                    <el-col :span="item.input_type == 'COMMENTS' ? 24:12" v-if="item.input_type == 'TEXT'">
                                        <el-form-item :label="item.label"
                                        >
                                            <el-input v-model="item.field_value"   :disabled="true"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="item.input_type == 'COMMENTS' ? 24:12" v-else-if="item.input_type == 'NUMBER'">
                                        <el-form-item :label="item.label"
                                        >
                                            <el-input v-model="item.field_value"  type="number" :disabled="true"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="item.input_type == 'COMMENTS' ? 24:12" v-else-if="item.input_type == 'DATE'">
                                        <el-form-item :label="item.label"
                                        >
                                            <el-date-picker
                                                    v-model="item.field_value"
                                                    type="date"
                                                    style="width: 100%"
                                                    format="yyyy-MM-dd"
                                                    value-format="yyyy-MM-dd"
                                                    :disabled="true">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="item.input_type == 'COMMENTS' ? 24:12" v-else-if="item.input_type == 'TRUE-FALSE'">
                                        <el-form-item :label="item.label"

                                        >
                                            <el-switch
                                                    v-model="item.field_value"
                                                    active-color="#13ce66"
                                                    active-value="T"
                                                    inactive-value = "F"
                                                    :disabled="true"
                                            >
                                            </el-switch>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="item.input_type == 'COMMENTS' ? 24:12" v-else-if="item.input_type == 'LIST'">
                                        <el-form-item :label="item.label"
                                        >
                                            <el-select v-model="item.field_value" :multiple="item.multiple == 'T'" placeholder="" style="width: 100%" :disabled="true">
                                                <el-option
                                                        v-for="item in item.listArray"
                                                        :key="item.key"
                                                        :label="item.value1"
                                                        :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="item.input_type == 'COMMENTS' ? 24:12" v-else>
                                        <el-form-item :label="item.label"
                                        >
                                            <el-input  :rows="3" v-model="item.field_value" type="textarea" :disabled="true"></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-form>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="变更历史" name="third" class="customer">
                            <el-row style="margin-top: 20px">
                                <el-table border :data="listData" header-cell-class-name="headerStyle2" stripe style="width: 100%" :default-sort = "{prop: 'date', order: 'descending'} ">
                                    <el-table-column type="index" :index="1" label="序号" style="font-size: 20px;color: #585757" width="65px"></el-table-column>
                                    <el-table-column
                                            prop="segment_name"
                                            label="客户级别"
                                            min-width="100px"
                                            sortable
                                    >
                                        <template slot-scope="scope">

                                            <div v-if="scope.row.old_segment_name !== scope.row.segment_name">
                                                <span style="margin-left: 5px; color: #4A90E2">{{scope.row.old_segment_name}}</span>
                                                <span style="color: #4A90E2"> -> </span>
                                                <span style="color: #4A90E2">{{scope.row.segment_name}}</span>
                                            </div>
                                            <div v-else="scope.row.old_segment_name == scope.row.segment_name">
                                                <span style="margin-left: 5px; color: #4A90E2">{{scope.row.old_segment_name}}</span><span style="color: #4A90E2">(无变化)</span>
                                            </div>

                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="status"
                                            label="目标客户"
                                            min-width="100px"
                                            sortable
                                    >
                                        <template slot-scope="scope">

                                            <div v-if="scope.row.account_status == scope.row.old_account_status">
                                                <span style="color: #4A90E2" v-if="scope.row.old_account_status=='ACTIVE'">是</span>
                                                <span style="color: #4A90E2" v-else="scope.row.old_account_status=='INACTIVE'">否</span>
                                                <span style="color: #4A90E2">(无变化)</span>
                                            </div>

                                            <div v-else="scope.row.account_status!== scope.row.old_account_status">
                                                <span style="margin-left: 5px; color: #4A90E2" v-if="scope.row.old_account_status=='ACTIVE'">是</span>
                                                <span style="margin-left: 5px; color: #4A90E2" v-else-if="scope.row.old_account_status=='INACTIVE'">否</span>
                                                <span style="color: #4A90E2"> -> </span>
                                                <span style="color: #4A90E2" v-if="scope.row.account_status=='ACTIVE'">是</span>
                                                <span style="color: #4A90E2" v-else-if="scope.row.account_status=='INACTIVE'">否</span>
                                            </div>

                                        </template>
                                    </el-table-column>


                                    <el-table-column
                                            prop="alias"
                                            label="人员"
                                            min-width="90px"
                                            sortable>
                                    </el-table-column>
                                    <el-table-column
                                            prop="created_date"
                                            label="变更提交日期"
                                            min-width="158px"
                                            sortable>
                                    </el-table-column>
                                    <el-table-column
                                            prop="effective_date"
                                            label="计划生效日期"
                                            min-width="158px"
                                            sortable>
                                    </el-table-column>

                                    <el-table-column
                                            prop="status_name"
                                            label="状态"
                                            min-width="100%"
                                            sortable>
                                    </el-table-column>
<!--                                    <el-table-column label="操作" width="72px">-->
<!--                                        <template slot-scope="scope">-->
<!--                                            <el-button v-if="scope.row.status == 'ACTIVE'"-->
<!--                                                       type="warning"-->
<!--                                                       size="mini"-->
<!--                                                       style="margin-right: 10px;float: left;background-color: #ff9901;border: #ff9901 1px solid;"-->
<!--                                                       @click="bianji(scope.row)"-->
<!--                                            >编辑-->
<!--                                            </el-button>-->

<!--                                            <el-button v-else-if="scope.row.status != 'ACTIVE'"-->
<!--                                                       type="warning"-->
<!--                                                       size="mini"-->
<!--                                                       style="margin-right: 10px;float: left;background-color: #ff9901;border: #ff9901 1px solid;"-->
<!--                                                       @click="xiangqing(scope.row)"-->
<!--                                            >详情-->
<!--                                            </el-button>-->
<!--                                        </template>-->
<!--                                    </el-table-column>-->
                                </el-table>
                            </el-row>
                            <div id="div1" style="display: block">
                                <div style="height: 40px; margin-top: 20px;">
                                    <el-col :span="18" style="color: #2b92fa;font-size: 20px;margin-top:10px;">
                                        客户变更详情
                                    </el-col>
                                    <el-col :span="6"style="">

                                        <el-button size="small" style="color: #fff;height: 36px;position: relative;top: 3px;background-color:#ff9901;border: #ff9901 1px solid;"  @click="tijiao">
                                            <img src="../../assets/images/tijiao.png" alt="" style="position: relative;right: 4px"><span style="position: relative;top: -3px;">提交变更</span>
                                        </el-button>
                                        <el-button size="medium" type="danger" style="color: #fff;position: relative;top: -1px;"  @click="quxiao">
                                            <span style="font-size: 12px">取消变更</span>
                                        </el-button>
                                    </el-col>
                                </div>
                                <div style="margin-top: 10px; border: 1px solid #ededed;background-color: #ecf3fc;border-radius: 5px" >
                                    <el-form ref="HcplistActive" :model="HcplistActive"  label-width="116px">
                                        <el-row>
                                            <el-col :span="9" style="padding-top: 23px">
                                                <el-form-item label="客户级别">
                                                    <el-select v-model="HcplistActive.segment_id" disabled placeholder="" style="width: 100%" clearable>
                                                        <el-option
                                                                v-for="item in Category"
                                                                :key="item.key"
                                                                :label="item.value1"
                                                                :value="item.key">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="9" style="padding-top: 23px">
                                                <el-form-item label="目标客户">
                                                    <el-switch
                                                            v-model="HcplistActive.account_status"
                                                            active-color="#13ce66"
                                                            active-value="ACTIVE"
                                                            inactive-value = "INACTIVE"
                                                            disabled
                                                    >
                                                    </el-switch>
                                                </el-form-item>
                                            </el-col>
<!--                                            <el-col :span="6" align="right"style="margin-top: 26px;padding-right: 20px">-->
<!--                                                <el-button type="danger" size="small" @click="closelist">-->
<!--                                                    取消-->
<!--                                                </el-button>-->
<!--                                            </el-col>-->
                                        </el-row>
                                        <el-row >
                                            <el-col :span="9" style="padding-top:-10px">
                                                <el-form-item label="生效时间">
                                                    <el-select v-model="HcplistActive.effective_date" placeholder="" disabled style="width: 100%" clearable>
                                                        <el-option label="当月生效" value="D"></el-option>
                                                        <el-option label="次月生效" value="C"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="15">
                                           <span style="color: #ED3B3F;font-size: 12px;margin-left: 10px;line-height: 37px">
                                               注意：生效日期如选择“本月生效”，将直接影响本月相关的绩效考核结果
                                           </span>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="20" style="padding-top: -10px">
                                                <el-form-item label="变更原因">
                                                    <el-input type="textarea" :rows="2" placeholder="" disabled v-model="HcplistActive.comments" >
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-form>
                                </div>
                            </div>


<!--                            <div id="div5">-->
<!--                                <div style="margin-top: 10px; border: 1px solid #ededed;background-color: #ecf3fc;border-radius: 5px">-->
<!--                                    <el-form ref="HcplistActive" :model="HcplistActive" label-width="116px">-->
<!--                                        <el-row>-->
<!--                                            <el-col :span="9" style="padding-top: 23px">-->
<!--                                                <el-form-item label="客户级别">-->
<!--                                                    <el-select v-model="HcplistActive.segment_id" placeholder="请选择对应的标准科室" style="width: 100%">-->
<!--                                                        <el-option-->
<!--                                                                v-for="item in Category"-->
<!--                                                                :key="item.key"-->
<!--                                                                :label="item.value1"-->
<!--                                                                :value="item.key">-->
<!--                                                        </el-option>-->
<!--                                                    </el-select>-->
<!--                                                </el-form-item>-->
<!--                                            </el-col>-->
<!--                                            <el-col :span="9" style="padding-top: 23px">-->
<!--                                                <el-form-item label="目标客户">-->
<!--                                                    <el-switch-->
<!--                                                            v-model="HcplistActive.account_status"-->
<!--                                                            active-color="#13ce66"-->

<!--                                                    >-->
<!--                                                    </el-switch>-->
<!--                                                </el-form-item>-->
<!--                                            </el-col>-->
<!--                                            <el-col :span="6" align="right"style="margin-top: 26px;padding-right: 20px">-->
<!--                                                <el-button type="danger" size="small" @click="closelist5">-->
<!--                                                    取消-->
<!--                                                </el-button>-->
<!--                                            </el-col>-->
<!--                                        </el-row>-->
<!--                                        <el-row >-->
<!--                                            <el-col :span="9" style="padding-top:-10px">-->
<!--                                                <el-form-item label="生效时间">-->
<!--                                                    <el-select v-model="HcplistActive.effective_date" placeholder="请选择生效时间" style="width: 100%">-->
<!--                                                        <el-option label="当月生效" value="D"></el-option>-->
<!--                                                        <el-option label="次月生效" value="C"></el-option>-->
<!--                                                    </el-select>-->
<!--                                                </el-form-item>-->
<!--                                            </el-col>-->
<!--                                            <el-col :span="15">-->
<!--                                           <span style="color: #ED3B3F;font-size: 12px;margin-left: 10px;line-height: 37px">-->
<!--                                               注意：生效日期如选择“本月生效”，将直接影响本月相关的绩效考核结果-->
<!--                                           </span>-->
<!--                                            </el-col>-->
<!--                                        </el-row>-->
<!--                                        <el-row>-->
<!--                                            <el-col :span="20" style="padding-top: -10px">-->
<!--                                                <el-form-item label="变更原因">-->
<!--                                                    <el-input type="textarea" :rows="2" placeholder="请输入变更原因" v-model="HcplistActive.comments">-->
<!--                                                    </el-input>-->
<!--                                                </el-form-item>-->
<!--                                            </el-col>-->
<!--                                        </el-row>-->
<!--                                    </el-form>-->
<!--                                </div>-->
<!--                            </div>-->



                        </el-tab-pane>
                    </el-tabs>






                </div>
            </div>
        </el-dialog>

        <!--零售详情-->
        <el-dialog
                :visible.sync="dialogVisible2"
                width="900px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3;margin-top: -70px">
            <div style="margin-top: -40px">
                <el-row style="padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;padding-top: 8px;font-size: 20px">门店详情
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">
                            <el-button type="danger" size="small" @click="dialogVisible2=false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-tabs v-model="activeName1" >
                    <el-tab-pane label="基本信息" class="basicInfo" name="first">
                        <el-form ref="storelist" :model="storelist" label-width="120px" style="margin-top: 20px;">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="名称" >
                                        <el-input v-model="storelist.store_name" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="门店编码" >
                                        <el-input v-model="storelist.store_code"  disabled></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="类别" >
                                        <el-select v-model="storelist.store_type_name"  style="width: 100%" disabled   placeholder="   ">
                                            <el-option
                                                    v-for="item in TypeList"
                                                    :key="item.key"
                                                    :label="item.value1"
                                                    :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="级别" >
                                        <el-select v-model="storelist.retailstore_grade_name"  style="width:100%" disabled   placeholder="   ">
                                            <el-option
                                                    v-for="item in GardeList"
                                                    :key="item.key"
                                                    :label="item.value1"
                                                    :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="省份" >
                                        <el-select v-model="storelist.province_name"  style="width: 100%" @change="fangfa" disabled   placeholder="   ">
                                            <el-option
                                                    v-for="item in data"
                                                    :key="item.province_id"
                                                    :label="item.province_name"
                                                    :value="item.province_id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="城市" >
                                        <el-select v-model="storelist.city_name"  style="width: 100%" disabled   placeholder="   ">
                                            <el-option
                                                    v-for="item in CityList"
                                                    :key="item.city_id"
                                                    :label="item.city_name"
                                                    :value="item.city_id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>


                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="地址">
                                        <el-input v-model="storelist.address" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="联系电话">
                                        <el-input v-model="storelist.telephone"  disabled></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="邮政编码">
                                        <el-input v-model="storelist.postcode"  disabled></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="官方网址">
                                        <el-input v-model="storelist.website" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="客户级别">
                                        <span style="color: #4A90E2" v-model="storelist.segment_name" disabled>{{storelist.segment_name}}</span>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="目标客户">
                                        <el-switch
                                                v-model="storelist.account_status"
                                                disabled
                                                active-color="#13ce66"
                                                disabled
                                        >
                                        </el-switch>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="扩展信息" name="second" class="extensionInfo">
                        <div class="subjectList" style="margin-top: 20px;">
                            <el-form   :ref="'list'+j" label-width="120px" v-for="(item,j) in extendedInfo2" :model="extendedInfo2[j]" :key="item.field_id">
                                <el-col :span="item.input_type == 'COMMENTS' ? 24:12" v-if="item.input_type == 'TEXT'">
                                    <el-form-item :label="item.label"
                                    >
                                        <el-input v-model="item.field_value"  :disabled="true"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="item.input_type == 'COMMENTS' ? 24:12" v-else-if="item.input_type == 'NUMBER'">
                                    <el-form-item :label="item.label"
                                    >
                                        <el-input v-model="item.field_value"  type="number" :disabled="true"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="item.input_type == 'COMMENTS' ? 24:12" v-else-if="item.input_type == 'DATE'">
                                    <el-form-item :label="item.label"
                                    >
                                        <el-date-picker
                                                v-model="item.field_value"
                                                type="date"
                                                style="width: 100%"
                                                format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd"
                                                :disabled="true">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="item.input_type == 'COMMENTS' ? 24:12" v-else-if="item.input_type == 'TRUE-FALSE'">
                                    <el-form-item :label="item.label"

                                    >
                                        <el-switch
                                                v-model="item.field_value"
                                                active-color="#13ce66"
                                                active-value="T"
                                                inactive-value = "F"
                                                :disabled="true"
                                        >
                                        </el-switch>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="item.input_type == 'COMMENTS' ? 24:12" v-else-if="item.input_type == 'LIST'">
                                    <el-form-item :label="item.label"
                                    >
                                        <el-select v-model="item.field_value" :multiple="item.multiple == 'T'" placeholder="" style="width: 100%" :disabled="true">
                                            <el-option
                                                    v-for="item in item.listArray"
                                                    :key="item.key"
                                                    :label="item.value1"
                                                    :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="item.input_type == 'COMMENTS' ? 24:12" v-else>
                                    <el-form-item :label="item.label"
                                    >
                                        <el-input  :rows="3" v-model="item.field_value"  type="textarea" :disabled="true"></el-input>
                                    </el-form-item>
                                </el-col>

                            </el-form>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="变更历史" name="third" class="customer">
                        <el-row style="margin-top: 20px">
                            <el-table border :data="listData2" stripe style="width: 100%" header-cell-class-name="headerStyle2" :default-sort = "{prop: 'date', order: 'descending'}">
                                <el-table-column type="index" :index="1" label="序号" style="font-size: 20px;color: #585757" width="65"></el-table-column>
                                <el-table-column
                                        prop="segment_name"
                                        label="客户级别"
                                        min-width="100px"
                                        sortable
                                >
                                    <template slot-scope="scope">

                                        <div v-if="scope.row.old_segment_name !== scope.row.segment_name">
                                            <span style="margin-left: 5px; color: #4A90E2">{{scope.row.old_segment_name}}</span>
                                            <span style="color: #4A90E2"> -> </span>
                                            <span style="color: #4A90E2">{{scope.row.segment_name}}</span>
                                        </div>
                                        <div v-else="scope.row.old_segment_name == scope.row.segment_name">
                                            <span style="margin-left: 5px; color: #4A90E2">{{scope.row.old_segment_name}}</span><span style="color: #4A90E2">(无变化)</span>
                                        </div>

                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="status"
                                        label="目标客户"
                                        min-width="100px"
                                        sortable
                                >
                                    <template slot-scope="scope">

                                        <div v-if="scope.row.account_status == scope.row.old_account_status">
                                            <span style="color: #4A90E2" v-if="scope.row.old_account_status=='ACTIVE'">是</span>
                                            <span style="color: #4A90E2" v-else="scope.row.old_account_status=='INACTIVE'">否</span>
                                            <span style="color: #4A90E2">(无变化)</span>
                                        </div>

                                        <div v-else="scope.row.account_status!== scope.row.old_account_status">
                                            <span style="margin-left: 5px; color: #4A90E2" v-if="scope.row.old_account_status=='ACTIVE'">是</span>
                                            <span style="margin-left: 5px; color: #4A90E2" v-else-if="scope.row.old_account_status=='INACTIVE'">否</span>
                                            <span style="color: #4A90E2"> -> </span>
                                            <span style="color: #4A90E2" v-if="scope.row.account_status=='ACTIVE'">是</span>
                                            <span style="color: #4A90E2" v-else-if="scope.row.account_status=='INACTIVE'">否</span>
                                        </div>

                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="alias"
                                        label="人员"
                                        min-width="90px"
                                        sortable>
                                </el-table-column>
                                <el-table-column
                                        prop="created_date"
                                        label="变更提交日期"
                                        min-width="158px"
                                        sortable>
                                </el-table-column>
                                <el-table-column
                                        prop="effective_date"
                                        label="计划生效日期"
                                        min-width="158px"
                                        sortable>
                                </el-table-column>

                                <el-table-column
                                        prop="status_name"
                                        label="状态"
                                        min-width="100%"
                                        sortable>
                                </el-table-column>
                            </el-table>

                        </el-row>
                        <el-form ref="storelistAction" :model="storelistAction"  label-width="120px">

                            <div id="div2" style="display: block">
                                <div style="height: 40px; margin-top: 20px;">
                                    <el-col :span="18" style="color: #2b92fa;font-size: 20px;margin-top:10px;">
                                        客户变更详情
                                    </el-col>
                                    <el-col :span="6"style="">

                                        <el-button size="small" style="color: #fff;height: 36px;position: relative;top: 3px;background-color:#ff9901;border: #ff9901 1px solid;"  @click="tijiao">
                                            <img src="../../assets/images/tijiao.png" alt="" style="position: relative;right: 4px"><span style="position: relative;top: -3px;">提交变更</span>
                                        </el-button>
                                        <el-button size="medium" type="danger" style="color: #fff;position: relative;top: -1px;"  @click="quxiao">
                                            <span style="font-size: 12px">取消变更</span>
                                        </el-button>
                                    </el-col>
                                </div>
                                <div style="margin-top: 10px; border: 1px solid #ededed;background-color: #ecf3fc;border-radius: 5px" >
                                    <el-row>
                                        <el-col :span="9" style="padding-top: 23px">
                                            <el-form-item label="客户级别">
                                                <el-select v-model="storelistAction.segment_id" placeholder="" disabled style="width: 100%" clearable>
                                                    <el-option
                                                            v-for="item in CategorySTORE"
                                                            :key="item.key"
                                                            :label="item.value1"
                                                            :value="item.key">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>

                                        <el-col :span="9" style="padding-top: 23px">
                                            <el-form-item label="目标客户">
                                                <el-switch
                                                        v-model="storelistAction.account_status"
                                                        active-color="#13ce66"
                                                        active-value="ACTIVE"
                                                        inactive-value = "INACTIVE"
                                                        disabled
                                                >
                                                </el-switch>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row >
                                        <el-col :span="9" style="padding-top: -10px">
                                            <el-form-item label="生效时间">
                                                <el-select v-model="storelistAction.effective_date" placeholder="" disabled style="width: 100%" clearable>
                                                    <el-option label="当月生效" value="D"></el-option>
                                                    <el-option label="次月生效" value="C"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="15">
                                       <span style="color: #ED3B3F;font-size: 12px;margin-left: 10px;line-height: 37px">
                                           注意：生效日期如选择“本月生效”，将直接影响本月相关的绩效考核结果
                                       </span>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="20" style="padding-top: -10px">
                                            <el-form-item label="变更原因">
                                                <el-input type="textarea" :rows="2" placeholder="" disabled v-model="storelistAction.comments">
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>

                                </div>
                            </div>

                        </el-form>
                    </el-tab-pane>
                </el-tabs>
                <div class="HcpClass" style="margin-top: 20px;">



                </div>

            </div>
        </el-dialog>

        <!--渠道详情-->
        <el-dialog
                :visible.sync="dialogVisible3"
                width="900px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3;margin-top: -70px">
            <div style="margin-top: -40px">
                <el-row style="padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;padding-top: 8px;font-size: 20px">经销商详情
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">

                            <el-button type="danger" size="small" @click="dialogVisible3=false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-tabs v-model="activeName2" >
                    <el-tab-pane label="基本信息" class="basicInfo" name="first">
                        <el-form ref="business" :model="business" label-width="120px" style="margin-top: 20px;">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="名称" >
                                        <el-input v-model="business.distributor_name"  disabled></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="经销商编码" >
                                        <el-input v-model="business.distributor_code"  disabled></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="类别" >
                                        <el-select v-model="business.distributor_type_name"  style="width: 100%" disabled   placeholder="   ">
                                            <el-option
                                                    v-for="item in TypeList"
                                                    :key="item.key"
                                                    :label="item.value1"
                                                    :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="级别" >
                                        <el-select v-model="business.distributor_grade_name"  style="width:100%" disabled   placeholder="   ">
                                            <el-option
                                                    v-for="item in GardeList"
                                                    :key="item.key"
                                                    :label="item.value1"
                                                    :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="省份" >
                                        <el-select v-model="business.province_name"  style="width: 100%" @change="fangfa2" disabled   placeholder="   ">
                                            <el-option
                                                    v-for="item in data"
                                                    :key="item.province_id"
                                                    :label="item.province_name"
                                                    :value="item.province_id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="城市" >
                                        <el-select v-model="business.city_name"  style="width: 100%" disabled   placeholder="   ">
                                            <el-option
                                                    v-for="item in CityList"
                                                    :key="item.city_id"
                                                    :label="item.city_name"
                                                    :value="item.city_id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>



                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="地址">
                                        <el-input v-model="business.address" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="联系电话">
                                        <el-input v-model="business.telephone"  disabled></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="邮政编码">
                                        <el-input v-model="business.postcode" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="官方网址">
                                        <el-input v-model="business.website" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="开发进度">

                                        <el-select v-model="business.agreement_stage" filterable  style="width: 100%" disabled   placeholder="   ">
                                            <el-option
                                                    v-for="item in AGREEMENT_STAGE"
                                                    :key="item.key"
                                                    :label="item.value1"
                                                    :value="item.key">
                                            </el-option>
                                        </el-select>

                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="已签约">
                                        <el-switch
                                                v-model="business.agreement_signed"
                                                active-color="#13ce66"
                                                disabled
                                        >
                                        </el-switch>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-form-item label="备注" >
                                <el-input v-model="business.comments"  type="textarea" disabled :autosize="{ minRows: 2}"></el-input>
                            </el-form-item>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="客户级别">
                                        <span style="color: #4A90E2" v-model="business.segment_name" disabled>{{business.segment_name}}</span>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="目标客户">
                                        <el-switch
                                                v-model="business.account_status"
                                                active-color="#13ce66"
                                                disabled
                                        >
                                        </el-switch>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="扩展信息" name="second" class="extensionInfo">
                        <div class="subjectList" style="margin-top: 20px;">
                            <el-form   :ref="'list'+j" label-width="120px" v-for="(item,j) in extendedInfo3" :model="extendedInfo3[j]" :key="item.field_id">
                                <el-col :span="item.input_type == 'COMMENTS' ? 24:12" v-if="item.input_type == 'TEXT'">
                                    <el-form-item :label="item.label"
                                    >
                                        <el-input v-model="item.field_value"  :disabled="true"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="item.input_type == 'COMMENTS' ? 24:12" v-else-if="item.input_type == 'NUMBER'">
                                    <el-form-item :label="item.label"
                                    >
                                        <el-input v-model="item.field_value"  type="number" :disabled="true"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="item.input_type == 'COMMENTS' ? 24:12" v-else-if="item.input_type == 'DATE'">
                                    <el-form-item :label="item.label"
                                    >
                                        <el-date-picker
                                                v-model="item.field_value"
                                                type="date"
                                                style="width: 100%"
                                                format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd"
                                                :disabled="true">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="item.input_type == 'COMMENTS' ? 24:12" v-else-if="item.input_type == 'TRUE-FALSE'">
                                    <el-form-item :label="item.label"

                                    >
                                        <el-switch
                                                v-model="item.field_value"
                                                active-color="#13ce66"
                                                active-value="T"
                                                inactive-value = "F"
                                                :disabled="true"
                                        >
                                        </el-switch>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="item.input_type == 'COMMENTS' ? 24:12" v-else-if="item.input_type == 'LIST'">
                                    <el-form-item :label="item.label"
                                    >
                                        <el-select v-model="item.field_value" :multiple="item.multiple == 'T'" placeholder="" style="width: 100%" :disabled="true">
                                            <el-option
                                                    v-for="item in item.listArray"
                                                    :key="item.key"
                                                    :label="item.value1"
                                                    :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="item.input_type == 'COMMENTS' ? 24:12" v-else>
                                    <el-form-item :label="item.label"
                                    >
                                        <el-input  :rows="3" v-model="item.field_value"  type="textarea" :disabled="true"></el-input>
                                    </el-form-item>
                                </el-col>

                            </el-form>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="变更历史" name="third" class="customer">
                        <el-row style="margin-top: 20px">
                            <el-table border :data="listData3" stripe style="width: 100%" header-cell-class-name="headerStyle2"  :default-sort = "{prop: 'date', order: 'descending'}">
                                <el-table-column type="index" :index="1" label="序号" style="font-size: 20px;color: #585757" width="65"></el-table-column>
                                <el-table-column
                                        prop="segment_name"
                                        label="客户级别"
                                        min-width="100px"
                                        sortable
                                >
                                    <template slot-scope="scope">

                                        <div v-if="scope.row.old_segment_name !== scope.row.segment_name">
                                            <span style="margin-left: 5px; color: #4A90E2">{{scope.row.old_segment_name}}</span>
                                            <span style="color: #4A90E2"> -> </span>
                                            <span style="color: #4A90E2">{{scope.row.segment_name}}</span>
                                        </div>
                                        <div v-else="scope.row.old_segment_name == scope.row.segment_name">
                                            <span style="margin-left: 5px; color: #4A90E2">{{scope.row.old_segment_name}}</span><span style="color: #4A90E2">(无变化)</span>
                                        </div>

                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="status"
                                        label="目标客户"
                                        min-width="100px"
                                        sortable
                                >
                                    <template slot-scope="scope">

                                        <div v-if="scope.row.account_status == scope.row.old_account_status">
                                            <span style="color: #4A90E2" v-if="scope.row.old_account_status=='ACTIVE'">是</span>
                                            <span style="color: #4A90E2" v-else="scope.row.old_account_status=='INACTIVE'">否</span>
                                            <span style="color: #4A90E2">(无变化)</span>
                                        </div>

                                        <div v-else="scope.row.account_status!== scope.row.old_account_status">
                                            <span style="margin-left: 5px; color: #4A90E2" v-if="scope.row.old_account_status=='ACTIVE'">是</span>
                                            <span style="margin-left: 5px; color: #4A90E2" v-else-if="scope.row.old_account_status=='INACTIVE'">否</span>
                                            <span style="color: #4A90E2"> -> </span>
                                            <span style="color: #4A90E2" v-if="scope.row.account_status=='ACTIVE'">是</span>
                                            <span style="color: #4A90E2" v-else-if="scope.row.account_status=='INACTIVE'">否</span>
                                        </div>

                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="alias"
                                        label="人员"
                                        min-width="90px"
                                        sortable>
                                </el-table-column>
                                <el-table-column
                                        prop="created_date"
                                        label="变更提交日期"
                                        min-width="158px"
                                        sortable>
                                </el-table-column>
                                <el-table-column
                                        prop="effective"
                                        label="计划生效日期"
                                        min-width="158px"
                                        sortable>
                                </el-table-column>

                                <el-table-column
                                        prop="status_name"
                                        label="状态"
                                        min-width="100%"
                                        sortable>
                                </el-table-column>
                            </el-table>
                        </el-row>
                        <el-form ref="businessActive" :model="businessActive"  label-width="95px">
                            <div id="div3" style="display: block">
                                <div style="height: 40px; margin-top: 20px;">
                                    <el-col :span="18" style="color: #2b92fa;font-size: 20px;margin-top:10px;">
                                        客户变更详情
                                    </el-col>
                                    <el-col :span="6"style="">

                                        <el-button size="small" style="color: #fff;height: 36px;position: relative;top: 3px;background-color:#ff9901;border: #ff9901 1px solid;"  @click="tijiao">
                                            <img src="../../assets/images/tijiao.png" alt="" style="position: relative;right: 4px"><span style="position: relative;top: -3px;">提交变更</span>
                                        </el-button>
                                        <el-button size="medium" type="danger" style="color: #fff;position: relative;top: -1px;"  @click="quxiao">
                                            <span style="font-size: 12px">取消变更</span>
                                        </el-button>
                                    </el-col>
                                </div>
                                <div style="margin-top: 10px; border: 1px solid #ededed;background-color: #ecf3fc;border-radius: 5px" >

                                    <el-row>
                                        <el-col :span="9" style="padding-top: 23px">
                                            <el-form-item label="客户级别">
                                                <el-select v-model="businessActive.segment_id" placeholder="" disabled style="width: 100%" clearable>
                                                    <el-option
                                                            v-for="item in CategoryDISTRIBUTOR"
                                                            :key="item.key"
                                                            :label="item.value1"
                                                            :value="item.key">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>

                                        <el-col :span="9" style="padding-top: 23px">
                                            <el-form-item label="目标客户">
                                                <el-switch
                                                        v-model="businessActive.account_status"
                                                        active-color="#13ce66"
                                                        active-value="ACTIVE"
                                                        inactive-value = "INACTIVE"
                                                        disabled
                                                >
                                                </el-switch>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row >
                                        <el-col :span="9" style="padding-top: -10px">
                                            <el-form-item label="生效时间">
                                                <el-select v-model="businessActive.effective" placeholder="" disabled style="width: 100%" clearable>
                                                    <el-option label="当月生效" value="D"></el-option>
                                                    <el-option label="次月生效" value="C"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="15">
                                       <span style="color: #ED3B3F;font-size: 12px;margin-left: 10px;line-height: 37px">
                                           注意：生效日期如选择“本月生效”，将直接影响本月相关的绩效考核结果
                                       </span>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="20" style="padding-top: -10px">
                                            <el-form-item label="变更原因">
                                                <el-input type="textarea" :rows="2" placeholder="" disabled v-model="businessActive.comments">
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>

                                </div>
                            </div>

                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-dialog>

    </div>

</template>


<script>
    //    import pagination from '../../components/pagination'

    // import TreeNode from './components/treeNode'
    import http from '../../APIService/http'
    import http2 from '../../APIService/http2'
    import {bus} from '../../router/index.js'
    import ImgUrl_n_red from '../../assets/images/folder_icon.png'
    import MiniCard from "../../components/MiniCards/index";
    import {Message} from "element-ui";

    export default {
        data() {
            return {
                val1:true,
                val:false,
                distributor_id:'',
                retailstore_id:'',
                institution_id:'',
                extendedInfo:[],
                extendedInfo2:[],
                extendedInfo3:[],
                activeName:'first',
                activeName1:'first',
                activeName2:'first',
                page: {
                    current: 1,
                    size: 5,
                    total: 0
                },
                isDisabled:'',
                AGREEMENT_STAGE:[],
                dialogVisible: false,
                dialogVisible2: false,
                dialogVisible3:false,
                loading: false,
                form:{
                    people:''
                },
                searchForm:{
                    account_name:'',
                    segment_id:'',
                    type:'',
                    time:'',
                    time2:'',
                    created_start_date :"",
                    created_end_date :"",
                    effective_start_date : "",
                    effective_end_date : "",
                },
                channelArray:[],
                listData:[{}],
                listData2:[{

                }],
                listData3:[{

                }],
                storelist:{},
                business:{},
                Hcplist:{
                },
                storelistAction:{
                    segment_id:'',
                    account_status:'',
                    comments:'',
                    effective_date:''
                },
                HcplistActive:{
                    segment_id:'',
                    comments:'',
                    effective_date:'',
                    account_status:''
                },
                businessActive:{
                    segment_id:'',
                    comments:'',
                    effective:'',
                    account_status:''
                },
                Category:[],
                UserList:[],
                ClientList:{
                    all_count:0,
                    hcp_count:0,
                    retailstore_count:0,
                    distributor_count:0
                },
                tableData:[],
                multipleSelection: [],
                accountArray:[],
                account_id:'',
                role:'',
                CategorySTORE:[],
                CategoryDISTRIBUTOR:[],
                ByCategory:[],
                clientObj:{},
            }
        },
        mounted() {


        },
        async created() {

            this.role=this.$store.getters.getUser.role

            this.form.people = this.$route.query.user_id
            if (this.form.people == null) {
                this.form.people = ''
            }
            if (this.form.people == undefined) {
                this.form.people = ''
            }
            this.clientObj=this.$store.getters.getClient

            this.getOuUserList()
            this.getDictionaryListByKOL_LEVEL2()
            this.getDictionaryListByCategory()
            this.getDictionaryListByCategory2()
            this.getDictionaryListByCategory3()
        },
        components:{
            MiniCard,
//            pagination
        },

        computed: {

        },
        methods: {
            fangfa3(value, option) {

                console.log(value)
                this.getDictionaryListByCategory4(value)
                this.searchForm.segment_id=''

            },
            renyuan(value,option){

                this.form.people = value

            },
            handleQueryClick(){
                this.getAccountListByStatusActive()
            },
            upDatabusiness2(){
                this.updateAccountDraftTwo()
                var oDiv2= document.getElementById("div2");
                oDiv2.style.display = "none";
                this.dialogVisible2=false
            },
            upDatabusiness(){
                this.updateAccountDraftOne()
                this.dialogVisible=false
                var oDiv1= document.getElementById("div1");
                oDiv1.style.display = "none";
            },
            upDatabusiness3(){
                this.updateAccountDraft()
                this.dialogVisible3=false
                var oDiv3= document.getElementById("div3");
                oDiv3.style.display = "none";
            },
            tijiao(){

                this.$confirm('确认提交变更?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    this.submitAccount()
                }).catch(() => {

                });
            },
            quxiao(){


                this.$confirm('是否取消变更?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    this.cancelAccount()
                }).catch(() => {

                });
            },
            handleSelectionChange(value){

                this.multipleSelection=value

                console.log(value)
                if(this.multipleSelection.length==0){
                    this.isDisabled=true
                    this.val1=true
                    this.val=false
                }else {
                    this.isDisabled=false
                    this.val1=false
                    this.val=true
                }
                this.accountArray=[]
                for(var i=0;i<this.multipleSelection.length;i++){
                    let account_id = this.multipleSelection[i].account_id
                    this.accountArray.push(account_id)
                }
                console.log(this.accountArray)

            },
            changePageClick(page, size) {
                if (page) {
                    this.page.current = page
                }
                if (size) {
                    this.page.size = size
                }
                console.log(this.page)
                this.init()
            },
            eventReset(){
                this.searchForm.account_name=''
                this.searchForm.segment_id=''
                this.channelArray=[]
                this.searchForm.time=''
                this.searchForm.time2=''
                this.searchForm.type=''
            },
            bianji2(item){
                console.log(item)
                var oDiv2 = document.getElementById("div2")
                oDiv2.style.display='block'
                var oDiv6 = document.getElementById("div6")
                oDiv6.style.display='none'
                this.account_id=item.account_id
                this.storelistAction.segment_id=item.segment_id
                this.storelistAction.comments=item.comments

                var date = new Date();
                let yyyymmdd = ''
                let y = date.getFullYear().toString();
                let m = date.getMonth()+1;
                if (m < 10){
                    yyyymmdd = y + '-' + '0' + m + '-01'
                }
                else {
                    yyyymmdd = y + '-' + m + '-01'
                }
                if(item.effective_date == yyyymmdd){
                    this.storelistAction.effective_date = 'D'
                }else {
                    this.storelistAction.effective_date = "C"
                }

                if(item.account_status=='ACTIVE'){
                    this.storelistAction.account_status=true
                }else {
                    this.storelistAction.account_status=false
                }
            },
            xiangqing2(item){
                var oDiv6 = document.getElementById("div6")
                oDiv6.style.display='block'
                var oDiv2 = document.getElementById("div2")
                oDiv2.style.display='none'
                this.account_id=item.account_id
                this.storelistAction.segment_id=item.segment_id
                this.storelistAction.comments=item.comments

                var date = new Date();
                let yyyymmdd = ''
                let y = date.getFullYear().toString();
                let m = date.getMonth()+1;
                if (m < 10){
                    yyyymmdd = y + '-' + '0' + m + '-01'
                }
                else {
                    yyyymmdd = y + '-' + m + '-01'
                }
                if(item.effective_date == yyyymmdd){
                    this.storelistAction.effective_date = 'D'
                }else {
                    this.storelistAction.effective_date = "C"
                }

                if(item.account_status=='ACTIVE'){
                    this.storelistAction.account_status=true
                }else {
                    this.storelistAction.account_status=false
                }
            },
            bianji(item){
                console.log(item)
                var oDiv1 = document.getElementById("div1")
                oDiv1.style.display='block'
                var oDiv5 = document.getElementById("div5")
                oDiv5.style.display='none'

                this.account_id=item.account_id
                this.HcplistActive.segment_id=item.segment_id
                this.HcplistActive.comments=item.comments

                var date = new Date();
                let yyyymmdd = ''
                let y = date.getFullYear().toString();
                let m = date.getMonth()+1;
                if (m < 10){
                    yyyymmdd = y + '-' + '0' + m + '-01'
                }
                else {
                    yyyymmdd = y + '-' + m + '-01'
                }
                if(item.effective_date == yyyymmdd){
                    this.HcplistActive.effective_date = 'D'
                }else {
                    this.HcplistActive.effective_date = "C"
                }

                if(item.account_status=='ACTIVE'){
                    this.HcplistActive.account_status=true
                }else {
                    this.HcplistActive.account_status=false
                }
            },
            xiangqing(item){
                console.log(item)
                var oDiv5 = document.getElementById("div5")
                oDiv5.style.display='block'
                var oDiv1 = document.getElementById("div1")
                oDiv1.style.display='none'
                this.account_id=item.account_id
                this.HcplistActive.segment_id=item.segment_id
                this.HcplistActive.comments=item.comments

                var date = new Date();
                let yyyymmdd = ''
                let y = date.getFullYear().toString();
                let m = date.getMonth()+1;
                if (m < 10){
                    yyyymmdd = y + '-' + '0' + m + '-01'
                }
                else {
                    yyyymmdd = y + '-' + m + '-01'
                }
                if(item.effective_date == yyyymmdd){
                    this.HcplistActive.effective_date = 'D'
                }else {
                    this.HcplistActive.effective_date = "C"
                }

                if(item.account_status=='ACTIVE'){
                    this.HcplistActive.account_status=true
                }else {
                    this.HcplistActive.account_status=false
                }
            },
            bianji3(item){
                var oDiv3 = document.getElementById("div3")
                oDiv3.style.display='block'
                var oDiv4 = document.getElementById("div4")
                oDiv4.style.display='none'

                this.account_id=item.account_id
                this.business.segment_id=item.segment_id
                this.business.comments=item.comments

                var date = new Date();
                let yyyymmdd = ''
                let y = date.getFullYear().toString();
                let m = date.getMonth()+1;
                if (m < 10){
                    yyyymmdd = y + '-' + '0' + m + '-01'
                }
                else {
                    yyyymmdd = y + '-' + m + '-01'
                }
                if(item.effective == yyyymmdd){
                    this.business.effective = 'D'
                }else {
                    this.business.effective = "C"
                }

                if(item.account_status=='ACTIVE'){
                    this.business.account_status=true
                }else {
                    this.business.account_status=false
                }
            },
            xiangqing3(item){
                var oDiv4 = document.getElementById("div4")
                oDiv4.style.display='block'
                var oDiv3 = document.getElementById("div3")
                oDiv3.style.display='none'
                this.account_id=item.account_id
                this.business.segment_id=item.segment_id
                this.business.comments=item.comments

                var date = new Date();
                let yyyymmdd = ''
                let y = date.getFullYear().toString();
                let m = date.getMonth()+1;
                if (m < 10){
                    yyyymmdd = y + '-' + '0' + m + '-01'
                }
                else {
                    yyyymmdd = y + '-' + m + '-01'
                }
                if(item.effective == yyyymmdd){
                    this.business.effective = 'D'
                }else {
                    this.business.effective = "C"
                }

                if(item.account_status=='ACTIVE'){
                    this.business.account_status=true
                }else {
                    this.business.account_status=false
                }
            },

            closelist4(){
                var oDiv4 = document.getElementById("div4")
                oDiv4.style.display='none'
            },
            closelist3(){
                var oDiv3 = document.getElementById("div3")
                oDiv3.style.display='none'
            },
            addlist2(){
                var oDiv2 = document.getElementById("div2")
                oDiv2.style.display='block'
            },
            closelist2(){
                var oDiv2 = document.getElementById("div2")
                oDiv2.style.display='none'
            },
            addlist(){
                var oDiv = document.getElementById("div1")
                oDiv.style.display='block'
            },
            closelist(){
                var oDiv = document.getElementById("div1")
                oDiv.style.display='none'
            },
            closelist5(){
                var oDiv = document.getElementById("div5")
                oDiv.style.display='none'
            },
            dianji(){
                this.$router.push({path:'shenpi',query:{user_id:this.form.people}});
            },
            dianji2(){
                this.$router.push({path:'shengxiao',query:{user_id:this.form.people}});
            },
            btn(row){
                this.accountArray.length = 0
                console.log(row)
                this.activeName = 'first'
                this.activeName1 = 'first'
                this.activeName2 = 'first'
                this.account_id=row.account_id
                this.getAccountInfo()
                this.accountArray.push(this.account_id)
                console.log(this.accountArray,88)

                //经销商
                if(row.reference_obj=="DISTRIBUTOR"){
                    this.dialogVisible3=true
                    this.getExtendedInfo3()
                };
                //hcp
                if(row.reference_obj=="HCP"){
                    this.dialogVisible=true
                    this.getExtendedInfo()
                }
                //门店
                if(row.reference_obj=="RETAILSTORE"){
                    this.dialogVisible2=true
                    this.getExtendedInfo2()
                };





            },
            //人员
            async getOuUserList(){


                let data = {
                    user_id: this.$store.getters.getUser.user_id,
                    tenant_id:this.$store.getters.getUser.tenant_id,

                }
                let self = this
                await http.post('/wapi/users/getOuUserList',data).then(res => {

                    if (res.success) {
                        self.UserList=res.data

                        for(var i=0;i<self.UserList.length;i++){
                            let a=self.UserList[i]
                            if(i==0 && this.form.people==''){
                                this.form.people=a.user_id
                            }
                        }
                        this.getAccountListByStatusActive()

                    }else {
                        Message.error(res.message);
                    }
                })
            },
            //级别
            async getDictionaryListByCategory(){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    category: "ACCOUNT_SEGMENT",
                    value2:'HCP'
                }
                let self = this
                await http.post('/wapi/v1/getDictionaryListByCategory',data).then(res => {

                    if (res.success) {
                        self.Category=res.data

                    }else {
                        Message.error(res.message);
                    }
                })
            },

            async getDictionaryListByCategory2(){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    category: "ACCOUNT_SEGMENT",
                    value2:'RETAILSTORE'
                }
                let self = this
                await http.post('/wapi/v1/getDictionaryListByCategory',data).then(res => {

                    if (res.success) {
                        self.CategorySTORE=res.data

                    }else {
                        Message.error(res.message);
                    }
                })
            },

            async getDictionaryListByCategory3(){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    category: "ACCOUNT_SEGMENT",
                    value2:'DISTRIBUTOR'
                }
                let self = this
                await http.post('/wapi/v1/getDictionaryListByCategory',data).then(res => {

                    if (res.success) {
                        self.CategoryDISTRIBUTOR=res.data

                    }else {
                        Message.error(res.message);
                    }
                })
            },

            async getDictionaryListByCategory4(value){
                let value2=''
                if(value=='RETAILSTORE'){
                    value2='RETAILSTORE'
                }
                if(value=='HCP'){
                    value2='HCP'
                }
                if(value=='DISTRIBUTOR'){
                    value2='DISTRIBUTOR'
                }
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    category: "ACCOUNT_SEGMENT",
                    value2:value2
                }
                let self = this
                await http.post('/wapi/v1/getDictionaryListByCategory',data).then(res => {

                    if (res.success) {
                        self.ByCategory=res.data

                    }else {
                        Message.error(res.message);
                    }
                })
            },

            //客户管理-目标客户列表
            async getAccountListByStatusActive(){
                this.loading=true
                let array = []
                for(var i= 0;i<this.channelArray.length;i++){
                    let obj=this.channelArray[i]
                    if(obj=='医疗机构'){
                        array.push("HCP")
                    }
                    else if(obj=='零售终端'){
                        array.push('RETAILSTORE')
                    }else if(obj=='分销客户'){
                        array.push('DISTRIBUTOR')
                    }
                }

                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    owner_id:this.$store.getters.getUser.user_id,//this.form.people,
                    effective_start_date:this.searchForm.time[0] == null ? "":this.searchForm.time[0],
                    effective_end_date:this.searchForm.time[1]  == null ? "":this.searchForm.time[1],
                    created_start_date:this.searchForm.time2[0] == null ? "":this.searchForm.time2[0],
                    created_end_date:this.searchForm.time2[1] == null ? "":this.searchForm.time2[1],
                    reference_obj:this.searchForm.type,
                    account_name:this.searchForm.account_name,
                    segment_id:this.searchForm.segment_id,
                    channelArray:array,
                    clientObj:this.$store.getters.getClient
                }
                let self = this

                await http.post('/wapi/TargetClient/getAccountListByStatusActive',data).then(res => {

                    if (res.success) {

                        self.ClientList=res.data
                        self.tableData=res.data.array
                        console.log(this.tableData)

                        self.page.total = parseInt( self.ClientList.list_count)

                    }else {
                        Message.error(res.message);
                    }
                    this.loading=false

                })
            },
            //取消变更
            async cancelAccount(){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    user_id: this.$store.getters.getUser.user_id,
                    accountArray:this.accountArray
                }

                await http.post('/wapi/TargetClient/cancelAccount',data).then(res => {

                    if (res.success) {

                        this.getAccountListByStatusActive()
                        this.dialogVisible = false
                        this.dialogVisible2 = false
                        this.dialogVisible3 = false

                    }else {
                        Message.error(res.message);
                    }
                })
            },
            //提交变更
            async submitAccount(){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    user_id: this.$store.getters.getUser.user_id,
                    accountArray:this.accountArray
                }

                await http.post('/wapi/TargetClient/submitAccount',data).then(res => {

                    if (res.success) {

                        this.getAccountListByStatusActive()
                        this.dialogVisible = false
                        this.dialogVisible2 = false
                        this.dialogVisible3 = false


                    }else {
                        Message.error(res.message);
                    }
                })
            },
            //详情
            async getAccountInfo(){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    account_id:this.account_id
                }

                await http.post('/wapi/TargetClient/getAccountInfo',data).then(res => {

                    if (res.success) {
                        console.log(res.data)
                        this.institution_id = res.data[0].institution_id
                        this.retailstore_id = res.data[0].retailstore_id
                        this.distributor_id = res.data[0].distributor_id
                        this.business=res.data[0]
                        this.listData3=res.data[0].AccountArray
                        this.Hcplist=res.data[0]
                        this.listData=res.data[0].AccountArray
                        this.storelist=res.data[0]
                        this.listData2=res.data[0].AccountArray


                        this.HcplistActive.segment_id = this.listData[0].segment_id
                        this.HcplistActive.account_status = this.listData[0].account_status
                        this.HcplistActive.comments = this.listData[0].comments
                        var date = new Date();
                        let yyyymm = ''
                        let y = date.getFullYear().toString();
                        let m = date.getMonth()+1;
                        if (m < 10){
                            yyyymm = y + '-' + '0' + m
                        }
                        else {
                            yyyymm = y + '-' + m
                        }
                        console.log(this.listData3[0],99)


                        this.storelistAction.segment_id = this.listData2[0].segment_id
                        this.storelistAction.account_status = this.listData2[0].account_status
                        this.storelistAction.comments = this.listData2[0].comments




                        this.businessActive.segment_id = this.listData3[0].segment_id
                        this.businessActive.account_status = this.listData3[0].account_status
                        this.businessActive.comments = this.listData3[0].comments
                        if(this.listData[0].effective_date){
                            var hcpStr = this.listData[0].effective_date.substring(0,7);
                            if(hcpStr == yyyymm){
                                this.HcplistActive.effective_date = 'D'
                            }else {
                                this.HcplistActive.effective_date = "C"
                            }
                        }
                        if(this.listData2[0].effective_date){
                            var storeStr = this.listData2[0].effective_date.substring(0,7);
                            if(storeStr == yyyymm){
                                this.storelistAction.effective_date = 'D'
                            }else {
                                this.storelistAction.effective_date = "C"
                            }
                        }
                        if(this.listData3[0].effective){
                            var businessStr = this.listData3[0].effective.substring(0,7);
                            if(businessStr == yyyymm){
                                this.businessActive.effective = 'D'
                            }else {
                                this.businessActive.effective = "C"
                            }
                        }




                        if(this.Hcplist.kol=='T'){
                            this.Hcplist.kol=true
                        }else {
                            this.Hcplist.kol=false
                        }

                        if(this.Hcplist.speaker=='T'){
                            this.Hcplist.speaker=true
                        }else {
                            this.Hcplist.speaker=false
                        }
                        if(this.Hcplist.account_status=='ACTIVE'){
                            this.Hcplist.account_status=true
                        }else {
                            this.Hcplist.account_status=false
                        }
                        if(this.Hcplist.status=='ACTIVE'){
                            this.Hcplist.status=true
                        }else {
                            this.Hcplist.status=false
                        }
                        if(res.data[0].agreement_signed=='T'){
                            this.business.agreement_signed=true
                        }else {
                            this.business.agreement_signed=false
                        }

                    }else {
                        Message.error(res.message);
                    }
                })
            },

            //编辑经销商
            async updateAccountDraft(){
                let status=''
                if(this.business.account_status==true){
                    status='ACTIVE'
                }else {
                    status='INACTIVE'
                }
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    account_id: this.account_id,
                    account_name: this.business.distributor_name,
                    account_status:status,
                    effective_date: this.business.effective,
                    distributor_id: this.business.distributor_id,
                    user_id: this.$store.getters.getUser.user_id,
                    segment_id: this.business.segment_id == null ? '':this.business.segment_id,
                    old_account_status: this.business.old_account_status,
                    old_segment_id: this.business.old_segment_id,
                    comments:this.business.comments

                }
                await http.post('/wapi/DistributorClient/updateAccountDraft',data).then(res => {

                    if (res.success) {
                        this.getAccountInfo()
                        this.getAccountListByStatusActive()
                    }else {
                        Message.error(res.message);
                    }
                    this.dialogVisible4=false

                })
            },
            //编辑hcp
            async updateAccountDraftOne(){
                let status=''
                if(this.HcplistActive.account_status==true){
                    status='ACTIVE'
                }else {
                    status='INACTIVE'
                }
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    account_id:this.account_id,
                    account_name:this.Hcplist.hcp_name,
                    account_status: status,
                    old_account_status:this.HcplistActive.old_account_status,
                    effective_date: this.HcplistActive.effective_date,
                    hcp_id: this.Hcplist.hcp_id,
                    user_id : this.$store.getters.getUser.user_id,
                    owner_id:this.form.UserList,
                    segment_id: this.HcplistActive.segment_id == null ? '' : this.HcplistActive.segment_id,
                    old_segment_id: this.Hcplist.old_segment_id,
                    comments:this.HcplistActive.comments
                }
                await http.post('/wapi/InstitutionClient/updateAccountDraft',data).then(res => {

                    if (res.success) {

                        this.getAccountInfo()
                        this.getAccountListByStatusActive()

                    }else {
                        Message.error(res.message);
                    }
                    this.dialogVisible4=false

                })
            },
            //编辑门店
            async updateAccountDraftTwo(){
                let status=''
                if(this.storelistAction.account_status==true){
                    status='ACTIVE'
                }else {
                    status='INACTIVE'
                }

                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    account_id:this.account_id,
                    account_name:this.storelist.store_name,
                    account_status: status,
                    effective_date:this.storelistAction.effective_date,
                    store_id: this.storelist.store_id,
                    user_id: this.$store.getters.getUser.user_id,
                    segment_id: this.storelistAction.segment_id == null ? "":this.storelistAction.segment_id ,
                    old_account_status: this.storelist. old_account_status,
                    old_segment_id:this.storelist.old_segment_id,
                    comments:this.storelistAction.comments
                }

                await http.post('/wapi/RetailstoreClient/updateAccountDraft',data).then(res => {

                    if (res.success) {
                        this.getAccountInfo()
                        this.getAccountListByStatusActive()
                    }else {
                        Message.error(res.message);
                    }
                    this.dialogVisible4=false

                })
            },

            async getDictionaryListByKOL_LEVEL2() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    category: "INSTITUTION_AGREEMENT_STAGE"
                }
                let self = this
                await http.post('/wapi/v1/getDictionaryListByCategory', data).then(res => {

                    if (res.success) {
                        self.AGREEMENT_STAGE = res.data

                    } else {
                        Message.error(res.message);
                    }

                })
            },
            async getExtendedInfo(){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    institution_id:this.institution_id
                }
                await http.post('/wapi/Institution/getExtendedInfo',data).then(res =>{

                    if (res.success) {
                        this.extendedInfo = res.data
                        console.log(this.extendedInfo,88)
                        this.extendedInfo.forEach(item=>{
                            if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value.indexOf('|') ==-1 && item.field_value !== ''){
                                item.field_value = [item.field_value]
                            }
                            if(item.input_type==="LIST" && item.field_value.indexOf('|')!==-1){
                                item.field_value = item.field_value.split('|')
                            }
                            if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value === ''){
                                item.field_value = []
                            }
                            if(item.input_type==="TRUE-FALSE" && item.field_value=== ""){
                                item.field_value = 'F'
                            }
                        })
                        console.log(this.extendedInfo,999)



                    }else {
                        Message.error(res.message);

                    }
                })
            },
            async getExtendedInfo2(){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    retailstore_id:this.retailstore_id
                }
                await http.post('/wapi/Retailstore/getExtendedInfo',data).then(res =>{

                    if (res.success) {
                        this.extendedInfo2 = res.data
                        console.log(this.extendedInfo2,88)
                        this.extendedInfo2.forEach(item=>{
                            if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value.indexOf('|') ==-1 && item.field_value !== ''){
                                item.field_value = [item.field_value]
                            }
                            if(item.input_type==="LIST" && item.field_value.indexOf('|')!==-1){
                                item.field_value = item.field_value.split('|')
                            }

                            if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value === ''){
                                item.field_value = []
                            }
                            if(item.input_type==="TRUE-FALSE" && item.field_value=== ""){
                                item.field_value = 'F'
                            }
                        })
                        console.log(this.extendedInfo2,999)



                    }else {
                        Message.error(res.message);

                    }
                })
            },
            async getExtendedInfo3(){
                let data={
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    distributor_id:this.distributor_id
                }
                await http.post('/wapi/Distributor/getExtendedInfo',data).then(res =>{

                    if (res.success) {
                        this.extendedInfo3 = res.data
                        console.log(this.extendedInfo3,88)
                        this.extendedInfo3.forEach(item=>{
                            if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value.indexOf('|') ==-1 && item.field_value !== ''){
                                item.field_value = [item.field_value]
                            }
                            if(item.input_type==="LIST" && item.field_value.indexOf('|')!==-1){
                                item.field_value = item.field_value.split('|')
                            }

                            if(item.input_type==="LIST" && item.multiple === 'T' && item.field_value === ''){
                                item.field_value = []
                            }
                            if(item.input_type==="TRUE-FALSE" && item.field_value=== ""){
                                item.field_value = 'F'
                            }
                        })
                        console.log(this.extendedInfo3,999)



                    }else {
                        Message.error(res.message);

                    }
                })
            },


        }
    }
</script>
<style lang="scss" module>
    .container {
        padding-top: 20px;
        padding-right: 20px;
        padding-left: 20px;
        padding-bottom: 20px;
        background: #fff;
        height: auto;

    }
</style>
<style scoped>
    .Peopel >>>.el-form-item__label{
        color: #000000;
        font-size: 16px;
    }
    .FormClass >>> .el-form-item__label{
        color: #000000;
        font-size: 14px;
        font-weight: bold;
        text-align: left;
    }
    .FormClass >>> .el-checkbox{
        width: 73px;
    }
    .FormClass{
        margin-top: 25px;
    }
    .HcpClass >>> .el-form-item__label{
        color: #000000;
        font-size: 14px;
        font-weight: bold;
    }
    .basicInfo >>> .el-form-item__label{
        color: #000000;
        font-size: 14px;
        font-weight: bold;
        text-align: left;
        padding-left: 20px;
    }
    .extensionInfo >>> .el-form-item__label{
        color: #000000;
        font-size: 14px;
        font-weight: bold;
        text-align: left;
        padding-left: 20px;
    }
    .customer >>> .el-form-item__label{
        color: #000000;
        font-size: 14px;
        font-weight: bold;
    }
    .businessClass >>> .el-form-item__label{
        color: #000000;
        font-size: 14px;
        font-weight: bold;
    }
</style>
<style>
    #div1{
        display: block;
    }
    #div2{
        display: none;
    }
    #div3{
        display: block;
    }
    #div4{
        display: none;
    }
    #div5{
        display: none;
    }
    #div6{
        display: none;
    }
    .headerStyle2 > div {
        font-size: 14px;
        color: #585757;
        font-weight: bold;
    }

    .headerStyle2:nth-last-of-type(2) > div {
        color: #4A90E2;
    }
   #target_home .active{
        background: #ff9901 !important;
        border: #ff9901 1px solid !important;
    }
   #target_home .inActive{
        background: #f3d19e !important;
        border: #f3d19e 1px solid !important;
    }
</style>





// WEBPACK FOOTER //
// src/pages/target/home.vue